module.exports = __webpack_public_path__ + "static/media/note-2_5.c955d480.png";